import toast from "react-hot-toast";
import {
    CREATE_PRODUCT,
    CREATE_PRICE,
    PRODUCTS_FAIL,
    EDIT_PRODUCT,
    EDIT_PRICE,
    GET_PRODUCTS,
    ATTACH_PRODUCT_SUCCESS,
    UPDATE_PLAN_PRODUCT_IDS,
    GET_PRICE_FOR_PRODUCT,
    RESET_PRODUCTS_DATA
} from "../constant";
import { t } from "i18next";

const initial = {
    products: [],
};

export const ProductsReducer = (state = initial, action) => {
    switch (action.type) {
        case PRODUCTS_FAIL:
            if(action.payload){
                // console.log(action.payload)
                toast.error(action.payload)
            }else{
                toast.error(t("views.productsManager.productManagerFail"))
            }
            return {
                ...state
            }
        case GET_PRICE_FOR_PRODUCT: 
            const existingProduct = state.products.find(p => p.productId == action.payload.productId)
            if(!existingProduct){
                return {
                    ...state,
                    products: [...state.products, action.payload]
                }
            }else{
                return {
                    ...state
                }
            }
        case RESET_PRODUCTS_DATA:
            return {
                ...state,
                products: []
            }
        default:
            return state;
    }
};